import React, { useContext, useEffect, useState } from "react";
import { Button, Container, styled } from "@mui/material";
import { useRouter } from "../../../utils/hooks/useRouter";
import { firebaseAndKvaLog } from "../../../services/analytics/analytic.service";
import { RetailContext } from "../../../contexts/retail/retailMain.context";
import { Redirect } from "../../../utils/Redirect";
import { updateRetailWebsiteStatus } from "../../../services/api/retail/websiteStatusApi";
import { getKVWebUrl } from "../../../services/domain/domainSetting.service";

const StyledOrderConfirmAppBar = styled("div")({
  position: "sticky",
  bottom: 0,
  zIndex: 3,
});

export default function BottomSetting({
  setOpenBottemSheetWelcome,
}: {
  setOpenBottemSheetWelcome?: any;
}) {
  const router = useRouter();
  const { branchInfo, merchantInfo, setBranchInfo } = useContext(RetailContext);
  const [link, setLink] = useState("");

  const handleShareWebsite = () => {
    firebaseAndKvaLog("retail", "kvapp_mk_setting_share");
    (window as any).sharePageLink(link, "retail");
    return;
  };

  const handlePublishWebsite = () => {
    const platform = router.query.platform;
    firebaseAndKvaLog("retail", "kvapp_mk_setting_public");
    if (!platform || typeof platform !== "string") {
      return () => {
        Redirect({ to: "/session-expired" });
      };
    }
    updateRetailWebsiteStatus({ step_code: 1, platform }).then(() => {
      let newBranchInfo = branchInfo;
      if (newBranchInfo) {
        if (setBranchInfo) {
          setBranchInfo({ ...newBranchInfo, is_active: true } ?? {});
        }
      }
      setOpenBottemSheetWelcome(true);
      // changeStatus && changeStatus(5);
    });
  };

  const handleViewWebsite = () => {
    if (branchInfo) {
      if (branchInfo.is_active) {
        firebaseAndKvaLog(router.query.platform, "kvapp_mk_setting_viewweb");
        if ((window as any).isWeb()) {
          window.open(link);
        } else {
          (window as any).openMyWebsite(link, "retail");
        }
        return;
      } else {
        const code = router.query.code ?? "";
        const url = `${process.env.REACT_APP_ADMIN_URL}/retail/m/preview?code=${code}`;
        window.location.replace(url);
      }
    }
  };

  useEffect(() => {
    setLink(getKVWebUrl(merchantInfo));
  }, [merchantInfo]);

  return (
    <StyledOrderConfirmAppBar>
      <Container
        className="fix-bottom"
        maxWidth="md"
        sx={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          padding: "8px 12px",
          backgroundColor: "#fff",
          zIndex: 1,
          display: "flex",
          gap: "8px",
          boxShadow:
            "0px 4px 24px rgba(0, 0, 0, 0.05), 0px 1px 5px rgba(0, 0, 0, 0.05)",
        }}
      >
        <Button
          size="large"
          variant="contained"
          sx={{
            boxShadow: "none",
            padding: "10px 0",
            borderRadius: "12px",
            color: "#0070F4",
            background: "#E5F1FE",
            fontWeight: 600,
            fontSize: "14px",
            lineHeight: "20px",
            fontFamily: "Inter,sans-serif",
            width: "50%",
            ":hover": {
              color: "#0070F4",
              background: "#E5F1FE",
            },
          }}
          onClick={handleViewWebsite}
        >
          <div>Xem website</div>
        </Button>

        {branchInfo && !branchInfo.is_active && (
          <Button
            size="large"
            variant="contained"
            sx={{
              boxShadow: "none",
              padding: "10px 0",
              borderRadius: "12px",
              background: "#0070F4",
              fontWeight: 600,
              fontSize: "14px",
              lineHeight: "20px",
              fontFamily: "Inter,sans-serif",
              width: "50%",
              color: "white",
            }}
            onClick={handlePublishWebsite}
          >
            <div>Xuất bản website</div>
          </Button>
        )}

        {branchInfo && branchInfo.is_active && (
          <Button
            size="large"
            variant="contained"
            sx={{
              boxShadow: "none",
              padding: "10px 0",
              borderRadius: "12px",
              background: "#0070F4",
              fontWeight: 600,
              fontSize: "14px",
              lineHeight: "20px",
              fontFamily: "Inter,sans-serif",
              width: "50%",
              color: "white",
            }}
            onClick={handleShareWebsite}
          >
            <div>Chia sẻ website</div>
          </Button>
        )}
      </Container>
    </StyledOrderConfirmAppBar>
  );
}
